import React, { useState, useEffect } from 'react';
import { trackButtonClick } from '../utils/analytics';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="header-content">
          <a href="#hero" className="logo" onClick={() => trackButtonClick('nav_hero', 'header_logo')}>
            <img src="/logo192.png" alt="" className="logo-icon" width="48" height="48" />
            <span className="logo-text">
              <span className="logo-main">Devil's Highway</span>
              <span className="logo-sub">Motorcycle Tours</span>
            </span>
          </a>
          
          <nav className="nav">
            <ul className="nav-list">
              <li><a href="#hero" className="nav-link" onClick={() => trackButtonClick('nav_hero', 'header')}>Home</a></li>
              <li><a href="#tour-details" className="nav-link" onClick={() => trackButtonClick('nav_tour-details', 'header')}>Tour Details</a></li>
              <li><a href="#itinerary" className="nav-link" onClick={() => trackButtonClick('nav_itinerary', 'header')}>Itinerary</a></li>
              <li><a href="#pricing" className="nav-link" onClick={() => trackButtonClick('nav_pricing', 'header')}>Pricing</a></li>
              <li><a href="#booking" className="nav-link" onClick={() => trackButtonClick('nav_booking', 'header')}>Book Now</a></li>
            </ul>
          </nav>

          <div className="header-cta">
            <a
              href="#booking"
              className="btn"
              onClick={() => trackButtonClick('book_your_ride', 'header_cta')}
            >
              Book Your Ride
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
